import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';
import { toJS } from 'mobx';
import Spinner from '../Spinner';

@inject('locationTypeStore')
@observer
class LocationList extends Component {
  render() {
    const { children, locationTypeStore } = this.props;
    if (locationTypeStore.isLoading) return <Spinner />

    let data = Object.assign([], toJS(locationTypeStore.items)).map(item => {
      item.parent = locationTypeStore.findById(item.parent_location);
      return item
    })

    return (
      <ItemList
        store={locationTypeStore}
        data={data}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'description', label: 'Description' },
          { key: 'parent.name', label: 'Parent Location' },
        ]}
        slug={'configurations/location/location-type'}
        resource={'configurations'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />

    );
  }
}

export default LocationList;



// WEBPACK FOOTER //
// ./src/components/Location/LocationTypeList.js